// Maps a column-menu text filter value { operator, values } to a GraphQL string
// filter clause on a HotChocolate-generated `where` input (AC-15377/AC-15498).
// Reused by every server-mode table that wires column filters into its
// `fetchData` `where`. Returns null for an unknown operator (caller skips it).
//
// Note: "Is Empty" / "Is Not Empty" compare against "" — meaningful only for
// NotNull string fields; omit those operators for columns where they don't
// apply (see TextColumnFilter's `operators` prop).
//
// Case sensitivity: server-side, only `contains` is case-insensitive (the
// QueryableStringInvariantContains handler in Host.cs); eq/neq/ncontains/in/nin
// are case-sensitive on Postgres. Client tables filter insensitively for all
// operators — an accepted cross-table difference (see textColumnFilterFn.js).
export default function textFilterToWhereClause({ operator, values }) {
  const v = values?.[0];
  switch (operator) {
    case "eq":
      return { eq: v };
    case "neq":
      return { neq: v };
    case "contains":
      return { contains: v };
    case "ncontains":
      return { ncontains: v };
    case "empty":
      return { eq: "" };
    case "nempty":
      return { neq: "" };
    case "in":
      return { in: values };
    case "nin":
      return { nin: values };
    default:
      return null;
  }
}
